import Icon from "components/icon";
import styled from "@emotion/styled";

export const StyledIndicator = styled(Icon)`
  font-size: 0.75rem;
  padding-bottom: 0.059rem;
`;
